export default __webpack_public_path__ + "assets/images/deadb3d557b95316912c1a1006d17c54.svg";